import React, { Component } from "react";
import {
  withStyles,
  Grid,
  Box,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  Snackbar,
  CircularProgress,
  Tooltip,
  TablePagination,
  TextField,
  InputAdornment,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import IconButton from "@material-ui/core/IconButton";
import { connect } from "react-redux";
import { Alert, Skeleton } from "@material-ui/lab";
import Header from "../../commons/Header/Header";
import axios from "axios";
import {
  URL,
  RAZORPAY_CLIENT_ID,
  baseURL,
  appURL,
  TENANT_ID,
} from "../../config/config";
import { checkAccess } from "../../helpers/RBAC";
import { updatePartnerStore } from "../../store/partnerState";
import ConfirmationDialog from "../Assistants/ConfirmationDialog";

const INVOICES_PER_PAGE = 10;

const INDIAN_STATES = [
  { label: "Andhra Pradesh", value: "AP" },
  { label: "Arunachal Pradesh", value: "AR" },
  { label: "Assam", value: "AS" },
  { label: "Bihar", value: "BR" },
  { label: "Chhattisgarh", value: "CG" },
  { label: "Goa", value: "GA" },
  { label: "Gujarat", value: "GJ" },
  { label: "Haryana", value: "HR" },
  { label: "Himachal Pradesh", value: "HP" },
  { label: "Jharkhand", value: "JH" },
  { label: "Karnataka", value: "KA" },
  { label: "Kerala", value: "KL" },
  { label: "Madhya Pradesh", value: "MP" },
  { label: "Maharashtra", value: "MH" },
  { label: "Manipur", value: "MN" },
  { label: "Meghalaya", value: "ML" },
  { label: "Mizoram", value: "MZ" },
  { label: "Nagaland", value: "NL" },
  { label: "Odisha", value: "OR" },
  { label: "Punjab", value: "PB" },
  { label: "Rajasthan", value: "RJ" },
  { label: "Sikkim", value: "SK" },
  { label: "Tamil Nadu", value: "TN" },
  { label: "Telangana", value: "TS" },
  { label: "Tripura", value: "TR" },
  { label: "Uttar Pradesh", value: "UP" },
  { label: "Uttarakhand", value: "UK" },
  { label: "West Bengal", value: "WB" },
  { label: "Delhi", value: "DL" },
];

class BillingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: false,
      alertMsg: "",
      alertSeverity: "",
      isEditing: false,
      isSaving: false,
      connectClicked: false,
      razorpayProfile: null,
      openDialog: false,
      disconnectLoader: false,
      isLoading: false,
      billingDetails: this.getBillingFromStore(),
      invoicePage: 0,
      invoices: [],
      invoiceTotal: 0,
      invoicesLoading: false,
      invoiceSearch: "",
      invoiceSearchTimeout: null,
    };
  }

  getBillingFromStore = () => {
    const ba = this.props.partner?.billingAddress || {};
    return {
      firstName: ba.firstName || "",
      lastName: ba.lastName || "",
      email: ba.email || "",
      phone: ba.phone || "",
      company: ba.company || "",
      line1: ba.line1 || "",
      line2: ba.line2 || "",
      city: ba.city || "",
      stateCode: ba.stateCode || "",
      zip: ba.zip || "",
      country: ba.country || "India",
      gstin: ba.gstin || "",
    };
  };

  componentDidMount() {
    this.fetchRazorpayProfile();
    this.fetchInvoices();
  }

  closeSnackbar = () => {
    this.setState({ alert: false, alertMsg: "", alertSeverity: "" });
  };

  toogleOpenDialog = () => {
    this.setState({ openDialog: !this.state.openDialog });
  };

  fetchRazorpayProfile = () => {
    this.setState({ isLoading: true });
    axios
      .post(URL + `/api/fetch-partner-razorpay-profile`, {
        partnerId: this.props.partner._id,
      })
      .then((response) => {
        this.setState({ razorpayProfile: response.data, isLoading: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          connectClicked: false,
          razorpayProfile: null,
          isLoading: false,
        });
      });
  };

  setupDisconnect = () => {
    this.setState({ disconnectLoader: true });
    axios
      .post(appURL + "/razorpay/partner/t1/disconnect", {
        partnerId: this.props.partner._id,
      })
      .then((response) => {
        this.setState({
          alert: true,
          alertSeverity: "success",
          alertMsg: "Successfully disconnected Razorpay",
          razorpayProfile: null,
          disconnectLoader: false,
        });
        this.toogleOpenDialog();
      })
      .catch((error) => {
        this.setState({
          alert: true,
          alertSeverity: "error",
          alertMsg: "Failed to disconnect Razorpay",
          disconnectLoader: false,
        });
        this.toogleOpenDialog();
      });
  };

  authenticateRazorpay = () => {
    const partnerId = this.props.partner._id;
    const billingAddress = this.props.partner.billingAddress;
    if (!billingAddress) {
      this.setState({
        alert: true,
        alertSeverity: "error",
        alertMsg: "No billing address found!",
      });
      return;
    }
    const callBackUrl = baseURL + "/integrations/appstore/app/razorpay/auth";
    const RazorpayClientId = RAZORPAY_CLIENT_ID;
    const authorizationUrl = `https://auth.razorpay.com/authorize?response_type=code&client_id=${RazorpayClientId}&redirect_uri=${callBackUrl}&scope=read_write&state=${partnerId}`;
    this.setState({ connectClicked: true }, () => {
      window.open(authorizationUrl, "_blank");
    });
  };

  fetchInvoices = (page = 0, search = "") => {
    this.setState({ invoicesLoading: true });
    const skip = page * INVOICES_PER_PAGE;
    const body = { skip, limit: INVOICES_PER_PAGE };
    if (search.trim()) body.search = search.trim();

    axios
      .post(URL + "/api/invoices", body)
      .then((response) => {
        const { invoices, total } = response.data;
        const newState = {
          invoices,
          invoicesLoading: false,
          invoicePage: page,
        };
        if (total !== undefined) newState.invoiceTotal = total;
        this.setState(newState);
      })
      .catch((error) => {
        console.error(error);
        this.setState({ invoicesLoading: false });
      });
  };

  handleBillingField = (field, value) => {
    this.setState((prev) => ({
      billingDetails: { ...prev.billingDetails, [field]: value },
    }));
  };

  openBillingDialog = () => {
    this.setState({
      isEditing: true,
      billingDetails: this.getBillingFromStore(),
    });
  };

  closeBillingDialog = () => {
    this.setState({ isEditing: false });
  };

  handleChangeInvoicePage = (event, newPage) => {
    this.fetchInvoices(newPage, this.state.invoiceSearch);
  };

  handleInvoiceSearch = (e) => {
    const value = e.target.value;
    if (this.state.invoiceSearchTimeout) {
      clearTimeout(this.state.invoiceSearchTimeout);
    }
    const timeout = setTimeout(() => {
      this.fetchInvoices(0, value);
    }, 500);
    this.setState({ invoiceSearch: value, invoiceSearchTimeout: timeout });
  };

  validateAndSave = () => {
    const bd = this.state.billingDetails;

    // Required fields check
    const required = [
      { key: "firstName", label: "First Name" },
      { key: "lastName", label: "Last Name" },
      { key: "email", label: "Email" },
      { key: "phone", label: "Phone" },
      { key: "company", label: "Company" },
      { key: "line1", label: "Address Line 1" },
      { key: "city", label: "City" },
      { key: "stateCode", label: "State" },
      { key: "zip", label: "PIN Code" },
      { key: "gstin", label: "GSTIN" },
    ];
    for (const f of required) {
      if (!bd[f.key] || !String(bd[f.key]).trim()) {
        this.setState({
          alert: true,
          alertSeverity: "error",
          alertMsg: `${f.label} is required`,
        });
        return;
      }
    }

    // First name / last name: letters only
    if (!/^[a-zA-Z\s]+$/.test(bd.firstName)) {
      this.setState({
        alert: true,
        alertSeverity: "error",
        alertMsg: "First Name should contain only letters",
      });
      return;
    }
    if (!/^[a-zA-Z\s]+$/.test(bd.lastName)) {
      this.setState({
        alert: true,
        alertSeverity: "error",
        alertMsg: "Last Name should contain only letters",
      });
      return;
    }

    // Email format
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(bd.email)) {
      this.setState({
        alert: true,
        alertSeverity: "error",
        alertMsg: "Please enter a valid email address",
      });
      return;
    }

    // Phone: 10 digits starting with 6-9
    if (!/^[6-9]\d{9}$/.test(bd.phone)) {
      this.setState({
        alert: true,
        alertSeverity: "error",
        alertMsg: "Please enter a valid 10-digit mobile number",
      });
      return;
    }

    // PIN code: exactly 6 digits
    if (!/^\d{6}$/.test(bd.zip)) {
      this.setState({
        alert: true,
        alertSeverity: "error",
        alertMsg: "Please enter a valid 6-digit PIN code",
      });
      return;
    }

    // GSTIN: exactly 15 alphanumeric characters
    if (!/^[0-9A-Z]{15}$/.test(bd.gstin)) {
      this.setState({
        alert: true,
        alertSeverity: "error",
        alertMsg: "Please enter a valid 15-character GSTIN",
      });
      return;
    }

    this.setState({ isSaving: true });
    const billingAddress = {
      firstName: bd.firstName.trim(),
      lastName: bd.lastName.trim(),
      email: bd.email.trim().toLowerCase(),
      phone: bd.phone.trim(),
      company: bd.company.trim(),
      line1: bd.line1.trim(),
      line2: bd.line2.trim(),
      city: bd.city.trim(),
      stateCode: bd.stateCode,
      zip: bd.zip.trim(),
      country: bd.country.trim(),
      gstin: bd.gstin.trim(),
    };

    axios
      .post(URL + "/api/update-partner-billing-details", { billingAddress })
      .then(() => {
        this.props.updatePartnerStore({ billingAddress });
        this.setState({
          isSaving: false,
          isEditing: false,
          alert: true,
          alertSeverity: "success",
          alertMsg: "Billing details updated successfully!",
        });
      })
      .catch((error) => {
        const errorMessage =
          error?.response?.data?.errorMessage ||
          "Error updating billing details!";
        this.setState({
          isSaving: false,
          alert: true,
          alertSeverity: "error",
          alertMsg: errorMessage,
        });
      });
  };

  renderBillingDialog = () => {
    const { classes } = this.props;
    const { billingDetails: bd, isSaving, isEditing } = this.state;

    return (
      <Dialog
        open={isEditing}
        maxWidth="sm"
        fullWidth
        disableBackdropClick
        disableEscapeKeyDown
        PaperProps={{ className: classes.billingDialogPaper }}
      >
        {/* Dialog Header */}
        <Box className={classes.dialogHeader}>
          <Box display="flex" alignItems="center" style={{ gap: 12 }}>
            <Box className={classes.dialogHeaderIcon}>
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#6d28d9"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
                <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
                <path d="M18 12a2 2 0 0 0 0 4h4v-4h-4z" />
              </svg>
            </Box>
            <Typography className={classes.dialogHeaderTitle}>
              Billing Information
            </Typography>
          </Box>
          <div
            onClick={this.closeBillingDialog}
            className={classes.dialogHeaderClose}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </div>
        </Box>

        <DialogContent className={classes.billingDialogContent}>
          {/* Contact Details Section */}
          <Typography className={classes.formSectionLabel}>
            CONTACT DETAILS
          </Typography>
          <div className={classes.formGrid}>
            <div>
              <input
                type="text"
                placeholder="First Name *"
                className={classes.nativeInput}
                value={bd.firstName}
                maxLength={50}
                onChange={(e) => {
                  if (/^[a-zA-Z\s]*$/.test(e.target.value))
                    this.handleBillingField("firstName", e.target.value);
                }}
              />
            </div>
            <div>
              <input
                type="text"
                placeholder="Last Name *"
                className={classes.nativeInput}
                value={bd.lastName}
                maxLength={50}
                onChange={(e) => {
                  if (/^[a-zA-Z\s]*$/.test(e.target.value))
                    this.handleBillingField("lastName", e.target.value);
                }}
              />
            </div>
            <div>
              <input
                type="email"
                placeholder="Email Address *"
                className={classes.nativeInput}
                value={bd.email}
                maxLength={100}
                onChange={(e) =>
                  this.handleBillingField("email", e.target.value.trim())
                }
              />
            </div>
            <div>
              <div className={classes.phoneRow}>
                <span className={classes.phonePrefix}>+91</span>
                <input
                  type="tel"
                  placeholder="Mobile Number *"
                  className={`${classes.nativeInput} ${classes.phoneInput}`}
                  value={bd.phone}
                  maxLength={10}
                  onChange={(e) => {
                    if (/^\d{0,10}$/.test(e.target.value))
                      this.handleBillingField("phone", e.target.value);
                  }}
                />
              </div>
            </div>
            <div className={classes.fullSpan}>
              <input
                type="text"
                placeholder="Company / Organisation Name *"
                className={classes.nativeInput}
                value={bd.company}
                maxLength={100}
                onChange={(e) =>
                  this.handleBillingField("company", e.target.value)
                }
              />
            </div>
          </div>

          {/* Billing Address Section */}
          <Typography
            className={classes.formSectionLabel}
            style={{ marginTop: 24 }}
          >
            BILLING ADDRESS
          </Typography>
          <div className={classes.formGrid}>
            <div className={classes.fullSpan}>
              <input
                type="text"
                placeholder="Address Line 1 *"
                className={classes.nativeInput}
                value={bd.line1}
                maxLength={120}
                onChange={(e) =>
                  this.handleBillingField("line1", e.target.value)
                }
              />
            </div>
            <div className={classes.fullSpan}>
              <input
                type="text"
                placeholder="Address Line 2 (Optional)"
                className={classes.nativeInput}
                value={bd.line2}
                maxLength={120}
                onChange={(e) =>
                  this.handleBillingField("line2", e.target.value)
                }
              />
            </div>
            <div>
              <input
                type="text"
                placeholder="City *"
                className={classes.nativeInput}
                value={bd.city}
                maxLength={60}
                onChange={(e) =>
                  this.handleBillingField("city", e.target.value)
                }
              />
            </div>
            <div>
              <select
                className={classes.nativeSelect}
                value={bd.stateCode}
                style={{ color: bd.stateCode ? "inherit" : "#6b7280" }}
                onChange={(e) => {
                  this.handleBillingField("stateCode", e.target.value);
                }}
              >
                <option value="">Select State *</option>
                {INDIAN_STATES.map((s) => (
                  <option key={s.value} value={s.value}>
                    {s.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <input
                type="text"
                placeholder="PIN Code *"
                className={classes.nativeInput}
                value={bd.zip}
                maxLength={6}
                onChange={(e) => {
                  if (/^\d{0,6}$/.test(e.target.value))
                    this.handleBillingField("zip", e.target.value);
                }}
              />
            </div>
            <div>
              <input
                type="text"
                placeholder="GSTIN *"
                className={classes.nativeInput}
                value={bd.gstin}
                maxLength={15}
                style={{ textTransform: "uppercase" }}
                onChange={(e) => {
                  const val = e.target.value.toUpperCase();
                  if (/^[0-9A-Z]{0,15}$/.test(val)) {
                    this.handleBillingField("gstin", val);
                  }
                }}
              />
            </div>
          </div>
        </DialogContent>

        <DialogActions className={classes.billingDialogActions}>
          <Button
            variant="outlined"
            size="small"
            className={classes.outlineBtn}
            onClick={this.closeBillingDialog}
            disabled={isSaving}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="small"
            className={classes.primaryBtn}
            onClick={this.validateAndSave}
            disabled={isSaving}
          >
            {isSaving ? <CircularProgress size={18} color="inherit" /> : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    const { classes, partner, partnerAgents, user } = this.props;
    const { billingAddress } = partner || {};
    const { line1, line2, city, zip, stateCode, country, company } =
      billingAddress || {};
    const isOwner = checkAccess(null, partnerAgents, user, null, null);
    const { razorpayProfile } = this.state;

    return (
      <div className={classes.root}>
        <Header businessTitle={"Billing"} />
        <Box my={3} />
        <Grid container justifyContent="center">
          <Grid item xs={12} md={11}>
            <Grid container spacing={2}>
              {/* Invoices Section */}
              <Grid item xs={12}>
                <Box className={classes.container}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    flexWrap="wrap"
                    style={{ gap: 12 }}
                  >
                    <Typography variant="h5" style={{ fontWeight: "600" }}>
                      Invoices
                    </Typography>
                    <TextField
                      variant="outlined"
                      size="small"
                      placeholder="Search Invoice ID"
                      value={this.state.invoiceSearch}
                      onChange={this.handleInvoiceSearch}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon
                              style={{ fontSize: 20, color: "#9ca3af" }}
                            />
                          </InputAdornment>
                        ),
                        style: { fontSize: 13, height: 32, padding: "0 8px" },
                      }}
                      style={{ width: 200 }}
                    />
                  </Box>
                  <Box className={classes.tableWrapper}>
                    <table className={classes.invoiceTable}>
                      <thead>
                        <tr>
                          <th className={classes.tableHeaderCell}>
                            Invoice No.
                          </th>
                          <th className={classes.tableHeaderCell}>Order ID</th>
                          <th className={classes.tableHeaderCell}>Date</th>
                          <th className={classes.tableHeaderCell}>
                            Description
                          </th>
                          <th
                            className={classes.tableHeaderCell}
                            style={{ textAlign: "right" }}
                          >
                            Amount
                          </th>
                          <th
                            className={classes.tableHeaderCell}
                            style={{ textAlign: "center" }}
                          >
                            Status
                          </th>
                          <th
                            className={classes.tableHeaderCell}
                            style={{ textAlign: "center" }}
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.invoicesLoading ? (
                          Array.from({ length: 3 }).map((_, i) => (
                            <tr key={i} className={classes.tableRow}>
                              {Array.from({ length: 7 }).map((__, j) => (
                                <td key={j} className={classes.tableCell}>
                                  <Skeleton variant="text" width="80%" />
                                </td>
                              ))}
                            </tr>
                          ))
                        ) : this.state.invoices.length === 0 ? (
                          <tr>
                            <td
                              colSpan={7}
                              style={{ textAlign: "center", padding: 32 }}
                            >
                              <Typography variant="body2" color="textSecondary">
                                {this.state.invoiceSearch
                                  ? "No invoices found"
                                  : "No invoices yet"}
                              </Typography>
                            </td>
                          </tr>
                        ) : (
                          this.state.invoices.map((inv) => (
                            <tr key={inv._id} className={classes.tableRow}>
                              <td className={classes.tableCell}>
                                <Typography
                                  variant="body2"
                                  style={{ fontWeight: 600 }}
                                >
                                  {inv.invoiceNumber || "-"}
                                </Typography>
                              </td>
                              <td
                                className={classes.tableCell}
                                style={{ maxWidth: 180 }}
                              >
                                <Box display="flex" alignItems="center" style={{ maxWidth: 180 }}>
                                  <Tooltip title={inv.orderId || ""}>
                                    <Typography
                                      variant="body2"
                                      noWrap
                                      style={{ color: "#6b7280", maxWidth: 150 }}
                                    >
                                      {inv.orderId || "-"}
                                    </Typography>
                                  </Tooltip>
                                  {inv.orderId && (
                                    <Tooltip title="Copy Order ID">
                                      <IconButton
                                        size="small"
                                        color="primary"
                                        onClick={() => {
                                          navigator.clipboard.writeText(inv.orderId);
                                        }}
                                        style={{ marginLeft: 4, padding: 4 }}
                                      >
                                        <FileCopyOutlinedIcon style={{ fontSize: 16 }} />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Box>
                              </td>
                              <td className={classes.tableCell}>
                                <Typography variant="body2">
                                  {inv.invoiceDate
                                    ? new Date(
                                        inv.invoiceDate,
                                      ).toLocaleDateString("en-IN", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })
                                    : "-"}
                                </Typography>
                              </td>
                              <td className={classes.tableCell}>
                                <Typography variant="body2">
                                  Central Balance Recharge
                                </Typography>
                              </td>
                              <td
                                className={classes.tableCell}
                                style={{ textAlign: "right" }}
                              >
                                <Typography
                                  variant="body2"
                                  style={{ fontWeight: 600 }}
                                >
                                  {inv.creditedAmount
                                    ? `₹${(inv.creditedAmount / 100000).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
                                    : "-"}
                                </Typography>
                              </td>
                              <td
                                className={classes.tableCell}
                                style={{ textAlign: "center" }}
                              >
                                <span
                                  className={classes.statusChip}
                                  style={{
                                    backgroundColor:
                                      inv.status === "PAID"
                                        ? "#ecfdf5"
                                        : "#fffbeb",
                                    color:
                                      inv.status === "PAID"
                                        ? "#059669"
                                        : "#d97706",
                                  }}
                                >
                                  {inv.status || "N/A"}
                                </span>
                              </td>
                              <td
                                className={classes.tableCell}
                                style={{ textAlign: "center" }}
                              >
                                {inv.pdfLink ? (
                                  <Button
                                    size="small"
                                    color="primary"
                                    variant="text"
                                    href={inv.pdfLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      textTransform: "none",
                                      fontSize: 13,
                                      fontWeight: 600,
                                      minWidth: "auto",
                                      padding: "2px 8px",
                                    }}
                                  >
                                    Download
                                  </Button>
                                ) : (
                                  <Typography
                                    variant="body2"
                                    color="textSecondary"
                                  >
                                    -
                                  </Typography>
                                )}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </Box>
                  <Box className={classes.paginationContainer}>
                    <TablePagination
                      component="div"
                      count={this.state.invoiceTotal}
                      page={this.state.invoicePage}
                      onPageChange={this.handleChangeInvoicePage}
                      rowsPerPage={INVOICES_PER_PAGE}
                      rowsPerPageOptions={[INVOICES_PER_PAGE]}
                    />
                  </Box>
                </Box>
              </Grid>
              {/* Razorpay Profile Setup Section */}
              {!TENANT_ID && isOwner && partner?.type === "WHITELABEL" && (
                <Grid item xs={12} md={6}>
                  {this.state.isLoading ? (
                    <Skeleton
                      variant="rect"
                      width="100%"
                      height={150}
                      style={{ borderRadius: 8, marginTop: 16 }}
                    />
                  ) : (
                    <Box
                      className={classes.container}
                      style={{
                        height: "80%",
                        padding: "20px",
                        paddingBottom: "10px",
                      }}
                    >
                      <Typography variant="h5" style={{ fontWeight: "600" }}>
                        Razorpay Profile Setup
                      </Typography>
                      {razorpayProfile?.status === "LIVE" ? (
                        <Box mt={2}>
                          <Typography
                            variant="body1"
                            color="textSecondary"
                            style={{ marginBottom: "12px" }}
                          >
                            Merchant ID: {razorpayProfile.merchantId?.slice(4)}
                          </Typography>
                        </Box>
                      ) : (
                        <Box mt={1}>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            style={{ marginBottom: "15px" }}
                          >
                            - Connect your Razorpay merchant account to automate
                            WCC payments.
                            <br />- Currently available exclusively for Indian
                            users.
                          </Typography>
                        </Box>
                      )}
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Box>
                            <Grid container>
                              <Grid item xs={12}>
                                {razorpayProfile?.status === "LIVE" ? (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-start"
                                    mt="10px"
                                    width="100%"
                                  >
                                    <Button
                                      variant="outlined"
                                      onClick={this.toogleOpenDialog}
                                      style={{
                                        color: "#fa5c5c",
                                        borderColor: "#fa5c5c",
                                        borderRadius: "6px",
                                        width: "30%",
                                      }}
                                      size="small"
                                    >
                                      Disconnect
                                    </Button>
                                  </Box>
                                ) : (
                                  <Box
                                    display="flex"
                                    justifyContent="flex-start"
                                    width="100%"
                                  >
                                    <Tooltip
                                      placement="bottom"
                                      interactive
                                      title={
                                        !billingAddress ? (
                                          <Typography
                                            variant="caption"
                                            color="primary"
                                            style={{
                                              fontSize: "0.70rem",
                                              cursor: "pointer",
                                            }}
                                            onClick={this.openBillingDialog}
                                          >
                                            Please add billing details →
                                          </Typography>
                                        ) : this.state.connectClicked ? (
                                          "Razorpay Integration in process"
                                        ) : (
                                          ""
                                        )
                                      }
                                    >
                                      <span>
                                        <Button
                                          color="primary"
                                          variant="contained"
                                          size="medium"
                                          style={{ borderRadius: "6px" }}
                                          disabled={
                                            !billingAddress ||
                                            this.state.connectClicked
                                          }
                                          onClick={this.authenticateRazorpay}
                                          className={classes.razorpayConnect}
                                          endIcon={
                                            this.state.connectClicked && (
                                              <CircularProgress
                                                size={18}
                                                style={{ color: "white" }}
                                              />
                                            )
                                          }
                                        >
                                          Connect Razorpay
                                        </Button>
                                      </span>
                                    </Tooltip>
                                  </Box>
                                )}
                              </Grid>
                            </Grid>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                </Grid>
              )}

              {/* Billing Details Section */}
              <Grid item xs={12} md={6}>
                <Box
                  className={classes.container}
                  style={{
                    height: "80%",
                    padding: "20px",
                    paddingBottom: "10px",
                  }}
                >
                  <Box className={classes.sectionHeader}>
                    <Typography variant="h5" style={{ fontWeight: "600" }}>
                      Billing Details
                    </Typography>
                    <Button
                      size="small"
                      color="primary"
                      variant="outlined"
                      style={{ height: 28, borderRadius: "6px" }}
                      onClick={this.openBillingDialog}
                    >
                      {billingAddress ? "Edit" : "Add"}
                    </Button>
                  </Box>
                  {billingAddress ? (
                    <Box style={{ marginTop: 12 }}>
                      <Typography variant="body2" style={{ lineHeight: 1.8 }}>
                        {!!company && (
                          <>
                            {company}
                            <br />
                          </>
                        )}
                        {!!line1 && <>{line1}, </>}
                        {!!line2 && <>{line2}, </>}
                        {!!city && `${city}, `}
                        {!!stateCode &&
                          `${INDIAN_STATES.find((s) => s.value === stateCode)?.label || stateCode}, `}
                        {!!country && country}
                        {!!zip && ` - ${zip}`}
                      </Typography>
                      {billingAddress.gstin && (
                        <Typography
                          variant="body2"
                          style={{ marginTop: 4, color: "#6b7280" }}
                        >
                          GSTIN: {billingAddress.gstin}
                        </Typography>
                      )}
                    </Box>
                  ) : (
                    <>
                      <Typography
                        variant="body2"
                        color="error"
                        style={{ margin: "12px 0" }}
                      >
                        Add your billing address.
                      </Typography>
                      <Box mt={10} />
                    </>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box my={8} />

        {/* Billing Edit Dialog */}
        {this.renderBillingDialog()}

        <Snackbar
          open={this.state.alert}
          autoHideDuration={4000}
          onClose={this.closeSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={this.closeSnackbar}
            severity={this.state.alertSeverity}
          >
            {this.state.alertMsg}
          </Alert>
        </Snackbar>
        <ConfirmationDialog
          openDialog={this.state.openDialog}
          closeDialog={this.toogleOpenDialog}
          title={"Disconnect Razorpay?"}
          body={
            <Typography variant="body1" paragraph style={{ color: "black" }}>
              Are you sure you want to disconnect? Doing so will remove your
              Razorpay merchant account, preventing you from processing
              automated WCC payments for your customers through Razorpay
            </Typography>
          }
          action={this.setupDisconnect}
          loader={this.state.disconnectLoader}
        />
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    width: "100%",
    height: "100%",
    background: "rgb(247,247,247)",
    boxSizing: "border-box",
    overflowX: "hidden",
    overflowY: "auto",
    position: "relative",
  },
  container: {
    // marginTop: 16,
    background: "white",
    borderRadius: 8,
    padding: "18px 36px",
  },
  sectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  razorpayConnect: {
    backgroundColor: "#3295fe",
    color: "white",
    padding: "6px 25px",
    "&:hover": {
      backgroundColor: "#3295fe",
    },
  },

  // Billing Dialog
  billingDialogPaper: {
    borderRadius: 16,
    maxWidth: 540,
    width: "100%",
    backgroundColor: "#ffffff",
    boxShadow: "0px 12px 30px rgba(0, 0, 0, 0.15)",
    margin: 16,
  },
  dialogHeader: {
    padding: "24px 24px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  dialogHeaderIcon: {
    backgroundColor: "#faf5ff",
    border: "1px solid #e9d5ff",
    borderRadius: "50%",
    width: 36,
    height: 36,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
  },
  dialogHeaderTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: "#111827",
    fontFamily: "Roboto, sans-serif",
  },
  dialogHeaderClose: {
    cursor: "pointer",
    color: "#9ca3af",
    padding: 4,
    display: "flex",
    borderRadius: 6,
    transition: "background 0.15s ease",
    "&:hover": {
      backgroundColor: "#f3f4f6",
    },
  },
  billingDialogContent: {
    padding: "24px !important",
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
  },
  billingDialogActions: {
    padding: "12px 24px 20px",
    display: "flex",
    justifyContent: "space-between",
  },
  outlineBtn: {
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 600,
    fontSize: 13,
    padding: "6px 20px",
    border: "1px solid #d1d5db",
    color: "#4b5563",
  },
  primaryBtn: {
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 600,
    fontSize: 13,
    padding: "6px 20px",
  },

  // Billing form styles (matching RechargeModal screen 2)
  formSectionLabel: {
    fontSize: 11,
    fontWeight: 700,
    color: "#9ca3af",
    letterSpacing: 0.8,
    marginBottom: 14,
    width: "100%",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 14,
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },
  fullSpan: {
    gridColumn: "1 / -1",
  },
  nativeInput: {
    padding: "12px 16px",
    border: "1px solid #d1d5db",
    borderRadius: 10,
    fontSize: 14,
    width: "100%",
    boxSizing: "border-box",
    outline: "none",
    backgroundColor: "#ffffff",
    fontFamily: "Roboto, sans-serif",
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
    "&:focus": {
      borderColor: "#6d28d9",
    },
    "&::placeholder": {
      color: "#9ca3af",
    },
  },
  nativeSelect: {
    padding: "12px 16px",
    border: "1px solid #d1d5db",
    borderRadius: 10,
    fontSize: 14,
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: "#ffffff",
    outline: "none",
    fontFamily: "Roboto, sans-serif",
    cursor: "pointer",
    textAlign: "left",
    WebkitAppearance: "none",
    MozAppearance: "none",
    appearance: "none",
    backgroundImage: `url('data:image/svg+xml;utf8,<svg fill="%236b7280" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>')`,
    backgroundRepeat: "no-repeat",
    backgroundPositionX: "calc(100% - 12px)",
    backgroundPositionY: "center",
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
    "&:focus": {
      borderColor: "#6d28d9",
    },
  },
  phoneRow: {
    display: "flex",
    alignItems: "stretch",
  },
  phonePrefix: {
    display: "flex",
    alignItems: "center",
    padding: "0 14px",
    backgroundColor: "#f9fafb",
    border: "1px solid #d1d5db",
    borderRight: "none",
    borderRadius: "10px 0 0 10px",
    color: "#6b7280",
    fontSize: 14,
    fontWeight: 500,
    fontFamily: "Roboto, sans-serif",
  },
  phoneInput: {
    borderRadius: "0 10px 10px 0 !important",
  },

  // Invoice table
  tableWrapper: {
    overflowX: "auto",
    marginTop: 16,
  },
  invoiceTable: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    fontFamily: "Roboto, sans-serif",
  },
  tableHeaderCell: {
    padding: "12px 16px",
    fontSize: 12,
    fontWeight: 700,
    color: "#9ca3af",
    textTransform: "uppercase",
    letterSpacing: 0.5,
    textAlign: "left",
    borderBottom: "1px solid #e5e7eb",
    whiteSpace: "nowrap",
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "#f9fafb",
    },
  },
  tableCell: {
    padding: "10px 16px",
    borderBottom: "1px solid #f3f4f6",
    whiteSpace: "nowrap",
  },
  statusChip: {
    display: "inline-block",
    padding: "3px 12px",
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 600,
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    borderTop: "1px solid #e5e7eb",
    // marginTop: 8,
  },
});

const connectedBillingPage = connect(
  (state) => ({
    partner: state.partner.partner,
    partnerAgents: state.partnerAgents.partnerAgents,
    user: state.login.user,
  }),
  { updatePartnerStore },
)(BillingPage);

export default withStyles(styles)(connectedBillingPage);
